// data/languages/swahili/categories/nourriture.ts

import { CategoryData } from '../../../../types/types';

export const nourriture: CategoryData = {
  'Maji': { translation: 'Eau', translationEn: 'Water', audio: 'Sw-maji', illustration: '💧' },

  'Mkate': { translation: 'Pain', translationEn: 'Bread', audio: 'Sw-mkate', illustration: '🍞' },

  'Wali': { translation: 'Riz', translationEn: 'Rice', audio: 'Sw-wali', illustration: '🍚' },

  'Pilau': { translation: 'Riz épicé', translationEn: 'Spiced rice', audio: 'Sw-pilau', illustration: '🍚🌶️' },

  'Nyama': { translation: 'Viande', translationEn: 'Meat', audio: 'Sw-nyama', illustration: '🥩' },

  'Samaki': { translation: 'Poisson', translationEn: 'Fish', audio: 'Sw-samaki', illustration: '🐟' },

  'Tende': { translation: 'Datte', translationEn: 'Date', audio: 'Sw-tende', illustration: '🌴' },

  'Karakara': { translation: 'Fruit de la passion', translationEn: 'Passion fruit', audio: 'Sw-karakara', illustration: '🍈' },

  'Tikiti maji': { translation: 'Pastèque', translationEn: 'Watermelon', audio: 'Sw-tikiti_maji', illustration: '🍉' },

  'Tini': { translation: 'Figue', translationEn: 'Fig', audio: 'Sw-tini', illustration: '🫐' },

  'Chungwa': { translation: 'Orange', translationEn: 'Orange', audio: 'Sw-chungwa', illustration: '🍊' },

  'Ndimu': { translation: 'Citron vert', translationEn: 'Lime', audio: 'Sw-ndimu', illustration: '🍈' },

  'Limau': { translation: 'Citron', translationEn: 'Lemon', audio: 'Sw-limau', illustration: '🍋' },

  'Ndizi': { translation: 'Banane', translationEn: 'Banana', illustration: '🍌' },

  'Yai': { translation: 'Œuf', translationEn: 'Egg', audio: 'Sw-yai', illustration: '🥚' },

  'Mboga': { translation: 'Légumes', translationEn: 'Vegetables', audio: 'Sw-mboga', illustration: '🥦🥕' },

  'Matunda': { translation: 'Fruits', translationEn: 'Fruits', audio: 'Sw-matunda', illustration: '🍎🍍🍓' },

  'Maziwa': { translation: 'Lait', translationEn: 'Milk', audio: 'Sw-maziwa', illustration: '🥛' },

  'Kahawa': { translation: 'Café', translationEn: 'Coffee', audio: 'Sw-kahawa', illustration: '☕' },

  'Chai': { translation: 'Thé', translationEn: 'Tea', audio: 'Sw-chai', illustration: '🍵' },

  'Sukari': { translation: 'Sucre', translationEn: 'Sugar', audio: 'Sw-sukari', illustration: '🍬' },

  'Chumvi': { translation: 'Sel', translationEn: 'Salt', audio: 'Sw-chumvi', illustration: '🧂' },

  'Mchuzi wa karanga': { translation: 'Sauce à base d\'arachide', translationEn: 'Peanut sauce', illustration: '🥜🥣' },

  'Kuku wa nazi': { translation: 'Poulet au lait de coco', translationEn: 'Chicken in coconut milk', illustration: '🐔🥥🍛' },

  'Ugali': { translation: 'Plat de base à base de farine de maïs', translationEn: 'Cornmeal staple dish', audio: 'Sw-ugali', illustration: '🍽️🌽' },

  'Chapati': { translation: 'Pain plat', translationEn: 'Flatbread', illustration: '🫓' },

  'Dawa': { translation: 'Boisson au gingembre et citron', translationEn: 'Ginger and lemon drink', illustration: '🫖🍋' },

  'Uji': { translation: 'Bouillie à base de farine', translationEn: 'Flour porridge', illustration: '🥣' },

  'Mandazi': { translation: 'Beignet épicé', translationEn: 'Spiced doughnut', audio: 'Sw-mandazi', illustration: '🍩' },

  'Samosa': { translation: 'Chausson frit farci', translationEn: 'Fried stuffed pastry', audio: 'Sw-samosa', illustration: '🥟' },

  'Maharagwe': { translation: 'Haricots en sauce', translationEn: 'Beans in sauce', audio: 'Sw-maharagwe', illustration: '🫘🍲' }
};

export default nourriture;

export {};
